import React from "react";
import "./Acerca.css";
import { getAcercaDocs } from "../../controllers/acerca.controller";

const Acerca = () => {
    const docs = getAcercaDocs();

    // 🔧 Función para detectar listas dentro del texto del modelo
    const renderDescripcion = (descripcion) => {
        // Divide el texto por líneas
        const lines = descripcion.split("\n").map((line) => line.trim()).filter(Boolean);

        // Si hay líneas con guiones ("- "), las convertimos en <ul><li>
        const hasBullets = lines.some((line) => line.startsWith("-"));

        if (hasBullets) {
            const titleLines = [];
            const bulletLines = [];

            for (const line of lines) {
                if (line.startsWith("-")) bulletLines.push(line.slice(1).trim());
                else titleLines.push(line);
            }

            return (
                <div className="card-desc">
                    {titleLines.map((line, i) => (
                        <p key={i}>{line}</p>
                    ))}
                    <ul className="card-list">
                        {bulletLines.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>
                </div>
            );
        }

        // Si no tiene guiones, se muestra como texto normal
        return <p className="card-desc">{descripcion}</p>;
    };

    return (
        <section className="acerca" aria-labelledby="acerca-title">
            <header className="acerca-header">
                <h1 id="acerca-title">Acerca de NutriPerformance</h1>
                <p className="acerca-lead">
                    NutriPerformance es una aplicación web diseñada como una herramienta
                    de apoyo para la toma de decisiones que facilita el desarrollo de
                    dietas equilibradas para el ganado, con un mínimo de desperdicio y
                    costos, y minimizando cualquier impacto negativo en el rendimiento
                    productivo o el bienestar animal.
                </p>
                <p className="acerca-lead">
                    Usando productos disponibles para las raciones y materias primas
                    producidas en el área de Sumapaz, es posible elaborar dietas
                    personalizadas basadas en la raza, peso, tipo de manejo (pastoreo o
                    encierro) y ganancia diaria deseada. Con esta información, el sistema
                    crea las mejores estrategias dietéticas y regímenes basados en lo que
                    está disponible localmente en términos de productos.
                </p>
                <p className="acerca-lead">
                    La herramienta fue desarrollada con tecnologías modernas para ser
                    intuitiva y altamente receptiva, lo que la hace flexible para su uso
                    en cualquier dispositivo. La estructura de la aplicación está
                    fragmentada bajo el patrón MVC (Modelo-Vista-Controlador) en React con
                    JavaScript y HTML/CSS, mientras que MySQL soporta el almacenamiento de
                    los datos. La solución es basada en la web y funciona en un navegador
                    de PC; los cálculos nutricionales se manejan en tiempo real y opera
                    incluso en áreas con baja conectividad.
                </p>
                <p className="acerca-lead">
                    NutriPerformance está basada en la combinación de la ingeniería de
                    sistemas y la nutrición animal, incorporando una variedad de las
                    tablas más reconocidas y metodologías de investigación a nivel
                    técnico, para ofrecer resultados robustos que pueden adaptarse a los
                    requisitos de los productores.
                </p>
            </header>

            <div className="acerca-grid">
                {docs.map((d) => (
                    <article key={d.titulo} className="acerca-card">
                        <h3>{d.titulo}</h3>
                        {renderDescripcion(d.descripcion)}
                        <a
                            href={d.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Descargar ${d.titulo} (PDF)`}
                            className="acerca-btn"
                        >
                            📄 Descargar PDF
                        </a>
                    </article>
                ))}
            </div>
        </section>
    );
};

export default Acerca;
